import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_114: FaireProductEntity = {
  token: "starter_collection_114",
  type: "product",
  name: "Gedeb Ethiopia - Organic",
  brandName: "Canyon Coffee",
  imageUrl:
    '"https://cdn.faire.com/fastly/f2dbdc284f06a367941fbc1774711a39258b3b540f27adf574055d12b1db643a.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1378',
  priceDollars: 24,
  msrpDollars: 48,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
